import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TimeSlotsDTO, TimeSlotsFilters } from '../../models/timeslots';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';

@Injectable({
    providedIn: 'root',
})
export class LaravelTimeSlotsService {
    constructor(private httpClient: HttpClient) {}

    private get ROUTES() {
        return {
          list: environment.baseUrl + '/api/timeslots',
          show: environment.baseUrl + '/api/timeslots',
          store: environment.baseUrl + '/api/timeslots',
          destroy: environment.baseUrl + '/api/timeslots',
        };
    }

    public list(
        page: number,
        per_page: number,
        order: string,
        direction: string,
        filters: TimeSlotsFilters,
        includes?: string[]
      ): Observable<ListResultDTO<TimeSlotsDTO>> {
        let params = {};
        if (order) params['order'] = '' + order;
        if (direction) params['direction'] = '' + direction;
        if (includes) params['includes[]'] = includes;
        if (filters) {
          //console.log("valore di filter active", filters.active);
          if (filters.active !== undefined && filters.active !== null) {
            params['active'] = filters.active;
          }
          if (filters.tenant_id) params["tenant_id"] = "" + filters.tenant_id;            

        }
        
        if (per_page) {
          params['per_page'] = '' + per_page;
          if (page) params['page'] = '' + page;
          return this.httpClient.get<ListResultDTO<TimeSlotsDTO>>(
            this.ROUTES.list,
            {
              params: new HttpParams({ fromObject: params }),
            }
          );
        } else {
          return this.httpClient
            .get<TimeSlotsDTO[]>(this.ROUTES.list, {
              params: new HttpParams({ fromObject: params }),
            })
            .pipe(
              map((results) => {
                return {
                  data: results,
                  total: results.length,
                };
              })
            );
        }
    }

    public show(id: number): Observable<TimeSlotsDTO> {
        let params = { id: '' + id };
        return this.httpClient.get<TimeSlotsDTO>(this.ROUTES.show, {
          params: new HttpParams({
            fromObject: params,
          }),
        });
    }

    public upsert(timeslot: TimeSlotsDTO): Observable<TimeSlotsDTO> {
        if (timeslot.id) {
          return this.httpClient.put<TimeSlotsDTO>(`${this.ROUTES.store}/${timeslot.id}`, {
            ...timeslot,
          });
        } else {
          return this.httpClient.post<TimeSlotsDTO>(`${this.ROUTES.store}`, {
            ...timeslot,
          });
        }
    }
    
    public delete(id: number) {
    let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
    }
}